import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { SenderListInterface } from '../types/sender-list';
import {
  SenderListFilter,
  defaultSenderListFilter,
} from '../types/sender-list-filter';

export const SENDER_LIST_STATE = 'senderList';

export interface SenderListState {
  filter: SenderListFilter;
  dataSource: DataSource<SenderListInterface[]>;
}

export const initialDataSource: DataSource<SenderListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialSenderListState: SenderListState = Object.freeze({
  filter: defaultSenderListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
